import { useEffect, useState } from 'react';
import { makeStyles, Theme, Button } from '@material-ui/core';
import { PARTICIPANT_TABLE_HEADER_UPCOMING, PARTICIPANT_TABLE_HEADER_COMLETED, PARTICIPANT_DASHBOARD_MENU } from '../../../../config/mock';
import { Helmet } from "react-helmet";
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { participantExperiences, updatePage } from '../../../../store/actions/participant/experience';
import UtilService from '../../../../helper/service';
import { useHistory } from 'react-router-dom';
import { Loading } from '../../../atoms/commonLoadings';
import { SESSION_SMALL_THUMBNAIL } from '../../../../config/mock';
import Config from '../../../../config/config';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flex: '1 1 auto',
    height: '100%',
    overflowX: 'hidden',
    background: '#F0F0F0',
    paddingTop: theme.spacing(2.5),
  },
  nav: {
    position: 'fixed',
    width: 210,
    marginTop: 20,
    padding: '8px 8px 0 22px'
  },
  table: {
    marginLeft: 210,
    marginRight: 18,
    paddinTop: 40,
  },
  folder: {
    display: 'flex',
    alignItems: 'center',
    height: 35,
    cursor: 'pointer!important'
  },
  folderName: {
    fontSize: 14,
    fontFamily: 'roboto-bold',
    color: '#697683',
    margin: '0 0 0 8px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  card: {
    boxShadow: '0px 0px 4px #00000033',
    borderRadius: 10
  },
  tr: {
    height: 65,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontFamily: 'roboto-regular',
    color: '#697683',
    background: '#fff',
    padding: '0 10px',
    fontSize: 14,
    lineHeight: 1.5,
    borderBottom: '1px solid #F5F5F5',
    '&:hover': {
      background: '#F2F7FC',
      cursor: 'pointer'
    }
  },
  img: {
    width: 83,
    height: 52,
    borderRadius: 10,
    border: '1px solid #f0f0f0',
    marginRight: 15
  },
  healthyText: {
    color: '#46C690',
    fontFamily: 'roboto-bold',
    fontSize: 14
  },
  dangerText: {
    color: '#EB6D9D',
    fontFamily: 'roboto-regular',
    fontSize: 14
  },
  left: {
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center'
  },
  header: {
    background: '#fff',
    borderRadius: '10px 10px 0px 0px',
  },
  headerContent: {
    height: 65,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontFamily: 'roboto-bold',
    color: '#606B76',
    fontSize: 12,
    borderBottom: '1px solid #D9D9D9',
    textTransform: 'uppercase',
    padding: '0 10px',

  },
  col: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 16px',
    overflow: 'hidden'
  },
  radiusBottom: {
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
  },
  center: {
    marginLeft: 18
  },
  loadMoreDiv: {
    textAlign: 'center',
    marginBottom: 5
  },
  loadMoreBtn: {
    padding: '6px 20px',
    background: '#017AEF',
    marginTop: 0,
    marginBottom: 25,
    color: '#fff',
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
    textTransform: 'none',
  }
}));

function ParticipantDashboard() {

  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [folderHover, setFolderHover] = useState(-1);
  const [status, setStatus] = useState(0);
  const { sessions, is_loaded, totalExperience, page, is_loading } = useSelector((state: any) => state.participant);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : {};

  if (is_loaded && sessions.length === 0) {
    history.push('/participant/planning/1');
  }

  useEffect(() => {
    !is_loaded && dispatch(participantExperiences(apolloClient.client, { page: page, size: 20 }))
  }, [is_loaded, dispatch, apolloClient.client])

  const opentModal = (u: string, e: string, session_code: string, sessionParticipants: any) => {
    let identifier = false
    const participants: any = sessionParticipants ? sessionParticipants : []
    if (loginUserData && loginUserData.username && participants.length) {
      const currentUser = participants.find((val: any) => val.temp_email === loginUserData.username)
      if (currentUser && currentUser.identifier) {
        identifier = currentUser.identifier
      }
    }

    // let desc = '';
    if (e === 'ASYNC') {
      // desc = 'This experience [event / opportunity] is not available yet. Please check back at a later time' 
      if (u === 'LIVE' || u === 'UPCOMING') {
        if (identifier) {
          window.open(`${Config.DEV_ASYNK_URL}/${session_code}/${identifier}`, "_blank");
        } else {
          window.open(`${Config.DEV_ASYNK_URL}/install/${session_code}?email=${loginUserData.username ? loginUserData.username : ""}`, "_blank");
        }
      } else if (u === 'COMPLETED') {
        window.open(`${Config.DEV_ASYNK_URL}/completed/${session_code}`, "_blank");
      }
    }
    if (e === 'MODERATED') {
      // desc = 'Your experience has not yet started. Please ch eck back at the schedule time for your experience' 
      if (u === 'LIVE' || u === 'UPCOMING') {
        if (identifier) {
          window.open(`${Config.DEV_MOD_URL}/${session_code}/${identifier}`, "_blank");
        } else {
          window.open(`${Config.DEV_MOD_URL}/install/${session_code}?email=${loginUserData.username ? loginUserData.username : ""}`, "_blank");
        }
      } else if (u === 'COMPLETED') {
        window.open(`${Config.DEV_MOD_URL}/completed/${session_code}`, "_blank");
      }
    }
  }

  if (!is_loaded) {
    return <Loading />
  }

  const loadMore = () => {
    if (page < Math.ceil(totalExperience / 10)) {
      dispatch(participantExperiences(apolloClient.client, { page: page + 1, size: 20 }))
      dispatch(updatePage(page + 1))
    }
  }

  const roundTime = (time: any) => {
    if (time !== "Processing...") {
      const minutesToRound = 60
      let [hours, minutes, second] = time.split(':');
      minutes = parseInt(minutes);
      second = parseInt(second);
      // Convert hours and minutes to time in minutes
      time = (minutes * 60) + second;
      const rounded = Math.round(time / minutesToRound) * minutesToRound;
      let rMin = Math.floor(rounded / 60)
      // let rMin =rounded % 60  
      if (rMin >= 60) {
        hours++
        rMin = 0
      }
      const hh = hours > 0 ? Number(hours) + " Hours" : ""
      const min = rMin > 0 ? Number(rMin) + " Minutes" : ""
      return hh + "" + ((hours > 0 && rMin > 0) ? " and " : " ") + min
    } else {
      return time
    }
  }
  return (
    <div className={classes.root}>
      <Helmet title="Participant" />

      <div className={classes.nav}>
        {PARTICIPANT_DASHBOARD_MENU.map((item, index) =>
          <div
            key={index}
            className={classes.folder}
            onMouseOver={() => setFolderHover(index)}
            onMouseLeave={() => setFolderHover(-1)}
            onClick={() => setStatus(index)}
          >
            <img
              alt={'img'}
              src={(folderHover === index || status === index) ? item.active : item.deactive}
            />
            <p className={classes.folderName}
              style={{ color: (folderHover === index || status === index) ? '#017AEF' : '' }}>
              {item.name}
            </p>
          </div>)}

      </div>

      <div className={classes.table}>
        <div className={clsx(classes.card)}>
          <div className={classes.header} >
            <div className={classes.headerContent}>
              {
                (status === 0 ? PARTICIPANT_TABLE_HEADER_UPCOMING : PARTICIPANT_TABLE_HEADER_COMLETED)
                  .map((item: any, index: number) =>
                    <div
                      key={index}
                      style={{ width: item.width }}
                      className={classes.col}
                    >
                      {item.title}
                    </div>
                  )
              }
            </div>
          </div>

          {
            //UPCOMING
            UtilService.filterCompleted(sessions, status === 0 ? 'UPCOMING' : 'COMPLETED')
              .map((item: any, index: number) =>
                <div
                  key={index}
                  onClick={() => opentModal(item.status, item.type, item.session_code, item.sessionParticipants)}
                >
                  <div className={clsx(classes.tr, index === sessions.length - 1 && classes.radiusBottom)}>
                    {
                      (status === 0 ? PARTICIPANT_TABLE_HEADER_UPCOMING : PARTICIPANT_TABLE_HEADER_COMLETED)
                        .map((x: any, k: number) =>
                          <div
                            key={k}
                            style={{ width: x.width }}
                            className={classes.col}
                          >
                            {x.img && <img
                              src={item.img ? item.img : ''}
                              alt={'img'}
                              className={classes.img}
                              onError={e => e.currentTarget.src = SESSION_SMALL_THUMBNAIL}
                            />}

                            {(x.param === 'immersion' || x.param === 'safety') ?
                              <div className={clsx(
                                classes.center,
                                item[x.param] && item[x.param] > 75 && classes.healthyText,
                                item[x.param] && item[x.param] < 35 && classes.dangerText)}
                              >
                                {item[x.param] ? item[x.param] : '-'}
                              </div> : (
                                x.param === 'status' ? item[x.param] ? UtilService.participantStatus(item[x.param]) : "-" :
                                  x.param === "type" ? item[x.param] ? item[x.param] === "ASYNC" ? "Watch Video " : "Live Experience" : "-" :
                                    x.param === 'length' ? item[x.param] && roundTime(item[x.param]) :
                                      item[x.param] ? item[x.param] : '-'
                              )}
                            {x.img}
                          </div>
                        )
                    }
                  </div>
                </div>)
          }
          {status == 0 && sessions && sessions.length > 0 && sessions.filter((item:any) => (item.status === "LIVE" || item.status === 0)).length > 1 && Math.ceil(totalExperience / 10) !== page && sessions.length !== totalExperience && (
            <div style={{justifyContent: 'center', alignItems: 'center', display: 'flex', marginTop: 15}}>
              {!is_loading && 
              <div className={classes.loadMoreDiv}>
                <Button className={classes.loadMoreBtn} onClick={loadMore}>
                  Load more...
                </Button>
              </div>
              }
              {is_loading && <Loading />}
            </div>
          )}
          {status != 0 && sessions && sessions.length > 0 && sessions.filter((item:any) => item.status === "COMPLETED").length > 1 && Math.ceil(totalExperience / 10) !== page && sessions.length !== totalExperience && (
            <div style={{justifyContent: 'center', alignItems: 'center', display: 'flex', marginTop: 15}}>
              {!is_loading &&
              <div className={classes.loadMoreDiv}>
                <Button className={classes.loadMoreBtn} onClick={loadMore}>
                  Load more...
                </Button>
              </div>
              }
              {is_loading && <Loading />}
            </div>
          )}

        </div>
      </div>

    </div>
  )
}

export default ParticipantDashboard;